var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrecciaP18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 72.7 693.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        mask: url(#mask);\n      }\n\n      .st2 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .st3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st4 {\n        fill: #2760ab;\n      }\n\n      .st5 {\n        fill: url(#Sfumatura_senza_nome_2);\n      }\n\n      .st6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 72.7,
    height: 693.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: -9,
    y: -28,
    width: 90.7,
    height: 722.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_2",
    "data-name": "Sfumatura senza nome 2",
    x1: -260.8,
    y1: 764.7,
    x2: -259.8,
    y2: 764.7,
    gradientTransform: "translate(-278572.1548 95286.105) rotate(90) scale(364.3508 -364.3508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -9,
    y: -28,
    width: 90.7,
    height: 722.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    y: 0,
    width: 72.7,
    height: 693.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -9,
    y: -28,
    width: 90.7,
    height: 722.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72.7 37.1 36.4 0 0 37.1 18.1 37.1 18.1 693.9 54.3 693.9 54.3 37.1 72.7 37.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrecciaP18);
export default __webpack_public_path__ + "static/media/freccia-p18.77b05023e9c97abdd3f2963dc9b362bb.svg";
export { ForwardRef as ReactComponent };